<ion-grid class="number">
  <ion-row class="picker">
    <ion-col
      *ngFor="let picker of value; let i = index; trackBy: trackByFn"
      class="ion-no-padding ion-no-margin"
      [size]="getColumnSize()"
      [ngClass]="{ first: i === 0, last: !isZodiac && i === value.length - 1 }"
    >
      <ion-picker
        class="ion-no-padding ion-no-margin"
        [ngStyle]="{
          '--highlight-background': getHighlightBackground(type ?? '')
        }"
      >
        <ion-picker-column
          (ionChange)="changePicker(i, $event)"
          [value]="value[i]"
          value="green"
          [disabled]="isPickerDisabled(i) || isLoadingTicket || notDraw"
        >
          <ion-picker-column-option
            *ngFor="let item of getCircularNumbers(value[i])"
            [value]="item"
            [attr.data-type]="type"
          >
            {{ item }}
          </ion-picker-column-option>
        </ion-picker-column>
      </ion-picker>
    </ion-col>

    <ion-col *ngIf="isZodiac" size="4" class="ion-no-padding last">
      <span class="picker-header">Elige tu signo</span>
      <ion-picker
        class="zodiac"
        [ngStyle]="{
          '--highlight-background': getHighlightBackground(type ?? '')
        }"
      >
        <ion-picker-column
          (ionChange)="changePickerZodiac($event)"
          [value]="valueZodiac"
          value="green"
          [disabled]="isLoadingTicket || notDraw"
          [compareWith]="compareZodiac"
        >
          <ion-picker-column-option [value]="{ name: '', idSigno: null }" value="black">
            <span></span>
          </ion-picker-column-option>
          <ion-picker-column-option *ngFor="let item of zodiac; let i = index" [value]="item" [attr.data-type]="type">
            <ion-icon size="small" [src]="'/assets/icons/zodiac/game-icons_' + item.icon + '.svg'"></ion-icon>
            <span>{{ item.name }}</span>
          </ion-picker-column-option>
        </ion-picker-column>
      </ion-picker>
    </ion-col>
  </ion-row>

  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-button
        (click)="searchNumber()"
        class="favorite-button ion-text-wrap"
        [disabled]="isLoadingTicket || notDraw || zodiacZero"
        expand="full"
      >
        <ion-icon slot="start" name="search"></ion-icon>
        <ion-text style="font-size: 7px">Buscar</ion-text>
      </ion-button>
    </ion-row>
  </ion-grid>

  <!-- Tickets search loading -->
  <div *ngIf="isLoadingTicket" class="loading-container">
    <ion-grid fixed>
      <ion-row class="ion-justify-content-center ion-align-items-center">
        <ion-col size="12" class="ion-text-center">
          <ion-spinner name="dots"></ion-spinner>
          <p>Buscando...</p>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-grid>
